/*
 * Copyright (c) 2023. All rights are reserved to Newport Collection
 */

import theme from 'components/theme';

const coreStyle = {
	search__wrapper: {
		position: 'relative',
		display: 'flex',
		minHeight: 38,
		maxWidth: 320,
		width: '100%',
		marginRight: 'auto',
		'&.focus': {
			position: 'absolute',
			top: 22,
			left: 0,
			bottom: 0,
			maxWidth: 'none'
		},
		[theme.breakpoints.down('sm')]: {
			display: 'block',
			overflowY: 'hidden',
			height: 'calc(100% - 90px)',
			width: '100%',
			minHeight: 40,
			maxWidth: 'none',
			margin: '0',
			padding: '0 15px !important',
			'&.hide': {
				display: 'none'
			},
			'&.right': {
				margin: '0 auto'
			},
			'&.focus': {
				top: 24
			}
		},
		[theme.breakpoints.down('lg')]: {
			padding: 0,
			'&.focus': {
				padding: '0 20px'
			}
		}
	},
	search__inner: {
		position: 'relative',
		zIndex: 100,
		width: '100%',
		[theme.breakpoints.down('sm')]: {
			zIndex: 100,
			padding: '20px 0',
			'.focus &': {
				transition: 'top 0.3s ease-out'
			}
		}
	},
	search__input: {
		width: '100%',
		height: 38,
		padding: '0.6rem 0.85rem',
		margin: 0,
		fontSize: 14,
		fontFamily: theme.typography.fontFamily,
		color: theme.palette.header.search.color,
		borderRadius: '4px',
		border: `1px solid ${theme.palette.primary.backgroundContrast}`,
		appearance: 'none',
		'&.glued': {
			borderRadius: 0
		},
		'&:focus-visible': {
			outline: 'none'
		},
		'&.glued.focus': {
			boxShadow: 'none'
		},
		'&.focus': {
			border: '1px solid transparent',
			boxShadow: theme.boxShadow[5],
			outline: 'none'
		},
		'&::placeholder': {
			color: theme.palette.header.search.color
		},
		'.xmas &': {
			background: theme.palette.primary.main,
			border: 'none',
			borderBottom: `1px solid ${theme.palette.header.search.color}`,
		},
		'.blackfriday &': {
			color: '#fff',
			backgroundColor: theme.palette.header.background,
			border: 'none',
			borderBottom: `1px solid #fff`,
			'&::placeholder': {
				color: '#fff',
			},
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: 16,
			boxShadow: 'none',
			height: 50,
			border: `1px solid ${theme.palette.primary.backgroundContrast}`,
			borderRadius: 0,
			'&.focus': {
				boxShadow: 'none',
				border: `1px solid ${theme.palette.primary.backgroundContrast}`,
			}
		}
	},
	icon__button: {
		transition: 'all .2s ease-in-out',
		position: 'absolute',
		minWidth: 'auto',
		minHeight: 'auto',
		padding: 10,
		borderTopLeftRadius: '0',
		borderBottomLeftRadius: '0',
		top: 0,
		right: 0,
		backgroundColor: 'transparent',
		[theme.breakpoints.down('sm')]: {
			borderRadius: 0,
			top: '50%',
			right: 0,
			height: 'auto',
			padding: 15,
			backgroundColor: 'rgba(0,0,0,0.9)',
			transform: 'translateY(-50%)',
			'.xmas &': {
				backgroundColor: theme.palette.primary.background,
				color: '#000'
			}
		},
		'&.focus': {
			backgroundColor: 'rgba(0,0,0,0.9)',
			'.xmas &': {
				backgroundColor: theme.palette.primary.background,
				color: '#000'
			}
		}
	},
	icon__button_search: {
		borderTopLeftRadius: '0',
		borderBottomLeftRadius: '0',
		'&.glued': {
			borderRadius: 0
		},
		'.xmas &': {
			color: '#fff !important',
		}
	},
	icon__button_close: {
		opacity: '0.8',
		borderRadius: '0',
		right: 40,
		padding: 10,
		backgroundColor: 'rgba(0,0,0,0)',
		'&:hover': {
			opacity: 1,
			backgroundColor: 'transparent'
		},
		[theme.breakpoints.down('sm')]: {
			opacity: 1,
			right: 65,
			padding: 14,
			backgroundColor: 'rgba(0,0,0,0.03)'
		},
		'&.focus': {
			backgroundColor: 'rgba(0,0,0,0.03)'
		}
	},
	search__icon: {
		width: 18,
		height: 18,
		'&.focus *': {
			stroke: theme.palette.primary.background,
			'.xmas &': {
				stroke: theme.palette.primary.main,
			}
		},
		[theme.breakpoints.down('sm')]: {
			'& *': {
				stroke: theme.palette.primary.background,
				'.xmas &': {
					stroke: theme.palette.primary.main,
				}
			}
		}
	},
	close__icon: {
		width: 18,
		height: 18,
		strokeWidth: 0.5,
		'& *': {
			fill: theme.palette.primary.foreground
		}
	},
	autocomplete: {
		display: 'none',
		overflowX: 'hidden',
		position: 'absolute',
		top: 50,
		left: 0,
		zIndex: 100,
		width: '100%',
		backgroundColor: theme.palette.primary.backgroundContrast,
		borderRadius: 4,
		boxShadow: theme.boxShadow[5],
		overflow: 'auto',
		maxWidth: theme.maxWidth,
		maxHeight: 'calc(100vh - 150px)',
		'&': {
			maxHeight: '-webkit-fill-available',
		},
		padding: 20,
		'&.glued': {
			boxShadow: 'none',
			borderRadius: 0
		},
		'&.focus': {
			display: 'block'
		},
		'&.center': {
			left: '-20px'
		},
		[theme.breakpoints.down('sm')]: {
			position: 'relative',
			top: 'unset',
			boxShadow: 'none',
			marginTop: 0,
			padding: '15px 15px 50px'
		},
		[theme.breakpoints.up('md')]: {
			width: 'calc(100% - 40px)',
			left: 20,
			maxHeight: 'none'
		},
		[theme.breakpoints.up('lg')]: {
			width: 'calc(100vw - 45px)',
			left: 0,
			maxHeight: 'none'
		}
	},
	suggestion: {
		width: 'auto',
		padding: 8,
		fontSize: 15,
		letterSpacing: '.15rem',
		opacity: 0,
		backgroundColor: theme.palette.primary.background,
		'&.focus': {
			transform: 'translateX(0)',
			opacity: 1,
			letterSpacing: '0'
		},
		'& a': {
			display: 'flex',
			alignItems: 'center',
			fontWeight: 400,
			color: 'inherit',
			textDecoration: 'none',
			whiteSpace: 'nowrap'
		},
		'& .searchIcon': {
			marginRight: 8,
			flexShrink: 0,
			color: '#000',
		}
	},
	suggestions__wrapper: {
		paddingBottom: 20,
		marginBottom: 15,
		borderBottom: `1px solid ${theme.palette.primary.backgroundContrast}`,
		'& ul': {
			display: 'flex',
			flexWrap: 'wrap',
			gap: 8
		},
		[theme.breakpoints.up('sm')]: {
			marginBottom: 0,
			borderRight: `1px solid ${theme.palette.primary.backgroundContrast}`,
			borderBottom: 'none'
		},
		[theme.breakpoints.down('sm')]: {
			'& li:nth-of-type(n + 6)': {
				display: 'none'
			}
		}
	},
	productSuggestion__link: {
		boxShadow: 'none'
	},
	products__wrapper: {
	},
	product: {
		display: 'flex',
		alignItems: 'center',
		padding: 8,
		textDecoration: 'none',
		opacity: 0,
		backgroundColor: theme.palette.primary.background,
		'&.focus': {
			opacity: 1,
		},
		'&:hover': {
			backgroundColor: theme.palette.primary.backgroundContrast
		},
		[theme.breakpoints.down('sm')]: {
			'&.focus': {
				transitionDelay: '.5s'
			}
		}
	},
	product__image: {
		position: 'relative',
		width: 90,
		marginRight: 10,
		overflow: 'hidden',
		'& > div': {
			display: 'block !important'
		},
		'&:after': {
			content: '""',
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			pointerEvents: 'none',
			mixBlendMode: 'multiply',
			boxShadow: 'inset 0 0 90px 8px rgb(240, 240, 240, 0.75)'
		}
	},
	product__info: {
		display: 'flex',
		flexDirection: 'column',
		alignSelf: 'center'

	},
	product__name: {
		fontSize: 15,
		fontWeight: 300,
		color: theme.palette.primary.text
	},
	product__prices: {
		display: 'flex'
	},
	product__price: {
		fontSize: 14,
		color: '#333',
		'&.special': {
			color: theme.palette.primary.special
		},
		'&.old': {
			marginLeft: 10,
			textDecoration: 'line-through',
			color: theme.palette.primary.disabled
		}
	},
	product__showMore: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: '100%',
		marginTop: 10,
		padding: '10px 15px',
		...theme.button.purchase,
		backgroundColor: theme.palette.primary.purchase.background,
		fontSize: 13,
		textDecoration: 'none',
		'&:hover': {
			backgroundColor: theme.palette.primary.purchase.hover,
		},
		'.xmas &': {
			backgroundColor: theme?.palette?.primary?.main
		}
	},
	noResultsText: {
		fontSize: 15,
		color: theme.palette.primary.foreground
	},
	relatedSearches: {
		marginTop: 5,
		marginBottom: 20,
		fontWeight: 600,
		fontSize: 15
	},
	obscure: {
		content: '""',
		position: 'fixed',
		zIndex: 99,
		top: 0,
		left: 0,
		right: 0,
		height: '0',
		opacity: 0,
		backgroundColor: 'rgba(0,0,0,0.5)',
		transition: 'opacity .2s, height 0.2s',
		transitionTimingFunction: 'ease-in',
		'&.show': {
			transition: 'opacity .5s, height .1s',
			height: '100vh',
			opacity: 1
		}
	}
};

module.exports = coreStyle;
